import React, { useEffect, useState } from 'react';
import { useAppSelector } from 'hooks';
import { selectCurrentTeamCustomersPermissions } from 'containers/app/appSlice';
import { VoidFn } from 'types/baseTypes';
import { ShareEstimateSection } from './ShareEstimateSection';
import { useLocation, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import SidePanel from 'components/side-panel/SidePanel';
import { SidePanelRouteState } from 'routes/types';
import { DEFAULT_SIDE_PANEL_ROUTE_STATE } from 'routes/constants';
import { ArrowRightIcon, CrossIconvector } from 'assets/icons';

interface ShareEstimatePanelProps {
  resetEstimatesQuery?: VoidFn;
  onClose?: VoidFn;
}

const ShareEstimatePanel: React.FC<ShareEstimatePanelProps> = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isRootState, setIsRootState] = useState(true);

  const customerPermissions = useAppSelector(selectCurrentTeamCustomersPermissions);

  const { estimateId } = useParams();
  const { handleSidePanelClose, resetEstimatesQuery } = useOutletContext<any>();

  useEffect(() => {
    let routeStateTimeout;
    const routeState: SidePanelRouteState = location.state ?? {};
    if (routeState?.fromSidePanel) {
      setIsRootState(false);
    }
    if (routeState?.shouldAnimate) {
      routeStateTimeout = setTimeout(() => {
        navigate(location.pathname, { replace: true, state: DEFAULT_SIDE_PANEL_ROUTE_STATE });
      }, 800);
    }
    return () => {
      clearTimeout(routeStateTimeout);
    };
  }, [location, navigate]);

  useEffect(() => {
    if (
      !customerPermissions.editCustomersCreatedByTeam &&
      !customerPermissions.editExistingCustomers &&
      !customerPermissions.viewCustomersCreatedByTeam
    ) {
      handleSidePanelClose();
    }
  }, [customerPermissions, handleSidePanelClose]);

  const handleSidePanelBack = () => {
    if (isRootState) {
      handleSidePanelClose();
    } else {
      navigate(-1);
    }
  };

  return (
    <SidePanel isOpen={true} onClose={handleSidePanelClose} shouldAnimate={location?.state?.shouldAnimate}>
      <div className="h-full w-96">
        <section className="customNormalScroll h-full w-full overflow-auto bg-white">
          <div className="flex cursor-pointer flex-row items-center bg-white p-4" onClick={handleSidePanelBack}>
            {isRootState ? (
              <CrossIconvector className="shrink-0" id="share-estimate-side-panel-close-button" />
            ) : (
              <ArrowRightIcon className="rotate-180" id="share-estimate-side-panel-back-button" />
            )}
            <div className="pl-2 text-17px font-semibold capitalize text-primaryText">Share Estimate</div>
          </div>
          {estimateId && <ShareEstimateSection estimateId={estimateId} resetEstimatesQuery={resetEstimatesQuery} />}
        </section>
      </div>
    </SidePanel>
  );
};

export default ShareEstimatePanel;
